export const testimonials = [
    {
        id: "bmw-x3-detailing",
        quote: "I brought my BMW X3 to Revautoz for their Premium Combo and was genuinely impressed with the transformation. The car came out looking fresh and the attention to detail was excellent. The team was professional throughout, and the whole setup feels like a proper premium detailing studio.",
        name: "BMW X3 Owner",
        vehicle: "BMW X3",
        service: "Detailing",
        rating: 5,
    },
    {
        id: "ppf-ceramic-owner",
        quote: "Got PPF and ceramic coating done at Revautoz and I'm really happy with the finish. The team explained everything properly and took their time with the installation. The paint looks amazing and the overall experience was smooth from start to finish.",
        name: "Premium Car Owner",
        vehicle: "Vehicle",
        service: "PPF / Ceramic",
        rating: 5,
    },
    {
        id: "restoration-owner",
        quote: "My car needed quite a bit of restoration work and Revautoz did a fantastic job bringing it back to life. From the paintwork to the smaller details, the difference was huge. Really impressed with the workmanship and how carefully the car was handled.",
        name: "Vehicle Owner",
        vehicle: "Vehicle",
        service: "Restoration",
        rating: 5,
    },
];
